function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgrammeStarterscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 332 265",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Starter-Screen---Programme-Mode",
    x: 0,
    y: 0,
    width: 331.649,
    height: 264.087,
    style: {
      fill: "#f7f0e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.524,191.487c-3.776,-2.173 -22.739,-12.439 -27.578,-16.492c-12.849,-10.762 -14.485,-29.017 -3.547,-39.956c10.882,-10.882 30.476,-12.637 41.835,-0.469c3.895,4.172 15.427,20.584 22.161,23.094c6.734,2.51 25.259,2.189 28.909,2.189c29.752,0 53.908,18.629 53.908,40.917c0,22.288 -24.155,40.382 -53.908,40.382c-11.672,0 -30.126,-3.341 -37.998,-9.543c-6.104,-4.809 -12.713,-12.242 -13.786,-18.034c-1.766,-9.533 -6.753,-20.221 -9.997,-22.088Z",
    style: {
      fill: "#f8bb37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.716,44.458c0.014,-0.65 -0.366,-0.395 -0.043,-0.623c1.488,-1.055 5.253,0.403 7.311,1.773c0.75,0.499 1.41,2.336 1.371,3.628c-0.507,16.702 -3.341,77.885 -4.41,96.584c-0.074,1.302 -1.974,0.797 -3.883,0.85c-1.945,0.054 -3.862,1.187 -3.867,-0.116c-0.065,-17.042 3.167,-85.498 3.523,-102.095Z",
    style: {
      fill: "#295439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.849,45.117l-6.097,160.327c-0.141,3.698 -3.257,6.586 -6.955,6.445l-127.338,-4.842c-3.698,-0.141 -6.586,-3.257 -6.445,-6.955l6.097,-160.327c0.141,-3.698 3.257,-6.586 6.955,-6.445l127.338,4.842c3.698,0.141 6.586,3.257 6.445,6.955Z",
    style: {
      fill: "#efe9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.583,122.427l-6.699,-6.598l2.976,-3.021l6.558,6.46l14.71,-14.784l2.633,2.619l-17.7,17.79l-2.478,-2.465Z",
    style: {
      fill: "#476b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.601,84.389l-6.699,-6.598l2.976,-3.021l6.558,6.46l14.71,-14.784l2.633,2.619l-17.7,17.79l-2.478,-2.465Z",
    style: {
      fill: "#476b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.732,160.759l-6.699,-6.598l2.976,-3.021l6.558,6.46l14.71,-14.784l2.633,2.619l-17.7,17.79l-2.478,-2.465Z",
    style: {
      fill: "#476b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.528,81.802l-0.02,1.517c-0.005,0.419 -0.35,0.754 -0.768,0.749l-55.191,-0.711c-0.419,-0.005 -0.754,-0.35 -0.749,-0.768l0.02,-1.517c0.005,-0.419 0.35,-0.754 0.768,-0.749l55.191,0.711c0.419,0.005 0.754,0.35 0.749,0.768Z",
    style: {
      fill: "#275236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.258,157.014l-0.019,1.517c-0.005,0.419 -0.349,0.754 -0.768,0.749l-55.191,-0.676c-0.419,-0.005 -0.754,-0.349 -0.749,-0.768l0.019,-1.517c0.005,-0.419 0.349,-0.754 0.768,-0.749l55.191,0.676c0.419,0.005 0.754,0.349 0.749,0.768Z",
    style: {
      fill: "#275236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.751,120.525l-0.018,1.517c-0.005,0.419 -0.349,0.754 -0.767,0.749l-55.192,-0.655c-0.419,-0.005 -0.754,-0.349 -0.749,-0.767l0.018,-1.517c0.005,-0.419 0.349,-0.754 0.767,-0.749l55.192,0.655c0.419,0.005 0.754,0.349 0.749,0.767Z",
    style: {
      fill: "#275236"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.972,
    cy: 77.901,
    r: 11.425,
    style: {
      fill: "#303030"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.169,
    cy: 107.986,
    r: 7.826,
    style: {
      fill: "#303030"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.76,
    cy: 125.499,
    r: 9.688,
    style: {
      fill: "#303030"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 267.599,
    cy: 182.779,
    r: 36.903,
    style: {
      fill: "#295439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.914,24.143l7.717,0.184c3.455,0.083 6.192,2.954 6.11,6.409l-0.299,12.518c-0.083,3.455 -2.954,6.192 -6.409,6.11l-48.928,-1.169c-3.455,-0.083 -6.192,-2.954 -6.11,-6.409l0.299,-12.518c0.083,-3.455 2.954,-6.192 6.409,-6.11l10.434,0.249c-0.167,-0.815 -0.254,-1.654 -0.254,-2.511c0,-7.705 7.048,-13.96 15.73,-13.96c8.682,0 15.73,6.255 15.73,13.96c0,1.118 -0.148,2.205 -0.428,3.247Zm-10.944,-0.261c0.72,-0.826 1.148,-1.862 1.148,-2.985c0,-2.697 -2.467,-4.886 -5.505,-4.886c-3.039,0 -5.505,2.189 -5.505,4.886c0,1.029 0.36,1.985 0.973,2.773c0.994,1.276 2.654,2.113 4.532,2.113c1.772,0 3.35,-0.745 4.357,-1.901Z",
    style: {
      fill: "#275236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.108,193.85l-9.751,-9.605l4.332,-4.398l9.546,9.404l21.413,-21.522l3.832,3.813l-25.767,25.897l-3.607,-3.589Z",
    style: {
      fill: "#efe9d9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammeStarterscreen);
export default __webpack_public_path__ + "static/media/programme-starterscreen.1dbf71a41920b06510fae765688bca79.svg";
export { ForwardRef as ReactComponent };